import {writable} from "svelte/store";
import type {ServerProduct} from "../@types/product";
import type {Currency, Platform} from "@fast-simon/types";
import type {ReportingObject} from "@fast-simon/fast-simon-reporting";
import type {BigcommerceCurrency} from "../@types/BCCurrency";
import {CDNCacheKey} from "@fast-simon/common"

export const uuid = writable<string>("");
export const storeID = writable<number>(0);
export const platform = writable<Platform>("Shopify");

export const cdnCacheKey = writable<string>(String(CDNCacheKey.getCDNCacheKey()));

export const products = writable<Record<string, ServerProduct[]>>({});

export const widgetWidth = writable<number>(0);
export const widgetHeight = writable<number>(0);
export const priceWidth = writable<number>(0);

/* reporting */
export const Reporting = writable<ReportingObject>();
export const ReportingProductsShownSlice = writable<string[]>([]);

/* preview */
export const previewMode = writable<boolean>(false);

/* Big Commerce Currency */
export const BCSiteCurrency = writable<Currency>("");
export const BCCurrenciesRates = writable<BigcommerceCurrency[]>();

/* dev mode */
export const viewedProduct = writable<string>("");
export const recentProducts = writable<string>("");

/* personalization */
export const promotedByPersonalizationProducts = writable<number[]>([]);